import { ArrowLeft } from "lucide-react";

const GALLERY = [
  {
    url: "/assets/directors/miykha-jersey.jpg",
    alt: "Miykhá Shepard in the maroon BGNZN number 1 jersey, studio session",
    caption: "Studio session — number 1, the house colors",
    anchor: "object-top",
  },
  {
    url: "/assets/directors/miykha-floor.jpg",
    alt: "Miykhá Shepard on the training floor in BGNZN sweats",
    caption: "On the floor — BGNZN from head to toe",
    anchor: "object-top",
  },
  {
    url: "/assets/cards/founding-proofs/front-miykha-shepard.png",
    alt: "Miykhá Shepard's founding card — the golden bear seal of the Institute",
    caption: "Founding proof — the golden bear seal",
  },
];

const DirectorMiykha = () => {
  return (
    <div className="min-h-screen bg-stone-950 text-stone-100">
      <div className="max-w-5xl mx-auto px-6 py-12 space-y-16">
        <a
          href="/#directors"
          data-testid="miykha-back-link"
          className="inline-flex items-center gap-2 text-xs text-stone-400 hover:text-amber-400 transition-colors"
        >
          <ArrowLeft size={14} /> Back to Directorship
        </a>

        {/* Hero */}
        <div className="grid md:grid-cols-5 gap-10 items-start">
          <div className="md:col-span-2 flex justify-center md:justify-start">
            <div
              className="w-52 sm:w-64 rounded-xl overflow-hidden border border-amber-500/30 shadow-[0_0_40px_rgba(245,158,11,0.10)]"
              data-testid="miykha-portrait"
            >
              <img
                src="/assets/directors/miykha-shepard-plaid.jpg"
                alt="Miykhá Shepard — Managing Director of Exchange Operations, in the house Burberry plaid"
                className="w-full h-[420px] object-cover object-[50%_20%]"
              />
            </div>
          </div>

          <div className="md:col-span-3 space-y-8">
            <div className="space-y-3">
              <span className="mono-tag text-xs uppercase tracking-widest text-amber-500 block">
                Managing Directorship
              </span>
              <h1 className="text-4xl sm:text-5xl font-bold tracking-tight display-serif">
                Miykhá Shepard
              </h1>
              <p className="text-stone-300 text-base md:text-lg">
                Exchange Operations
              </p>
              <p className="text-xs text-stone-500">The Bourg Merchant Exchange</p>
            </div>

            <div className="space-y-4" data-testid="miykha-credentials">
              <div className="border-b border-stone-800/70 pb-3">
                <p className="mono-tag text-[10px] uppercase tracking-widest text-stone-500">Office</p>
                <p className="text-sm text-stone-200 mt-1">
                  Managing Director — Exchange Operations: the banking bridge, partner rails,
                  and the member ledger's day-to-day integrity
                </p>
              </div>
              <div className="border-b border-stone-800/70 pb-3">
                <p className="mono-tag text-[10px] uppercase tracking-widest text-stone-500">Desk</p>
                <p className="text-sm text-stone-200 mt-1">The Bourg Merchant Exchange — Henderson &amp; Las Vegas, Nevada</p>
              </div>
            </div>

            <div className="rounded-xl bg-stone-900/60 border border-stone-800 p-5 space-y-2">
              <p className="mono-tag text-[10px] uppercase tracking-widest text-amber-500">The Desk</p>
              <p className="text-xs text-stone-400 leading-relaxed">
                Director Shepard runs the exchange's operating core — the rails members' money
                actually travels. His full dossier opens with the Institute's launch film.
              </p>
            </div>
          </div>
        </div>

        {/* Gallery */}
        <section className="space-y-6" data-testid="miykha-gallery">
          <span className="mono-tag text-xs uppercase tracking-widest text-amber-500 block">
            Off the Ledger
          </span>
          <div className="grid sm:grid-cols-2 gap-6 max-w-3xl">
            {GALLERY.map((shot) => (
              <figure
                key={shot.url}
                className="rounded-xl overflow-hidden bg-stone-900/60 border border-stone-800 group"
              >
                <div className="aspect-[4/5] overflow-hidden">
                  <img
                    src={shot.url}
                    alt={shot.alt}
                    className={`w-full h-full object-cover ${shot.anchor || "object-center"} group-hover:scale-105 transition-transform duration-700`}
                    loading="lazy"
                  />
                </div>
                <figcaption className="px-4 py-3 text-xs text-stone-400">{shot.caption}</figcaption>
              </figure>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default DirectorMiykha;
